import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient';
import type { Chat } from '@trinity/chat';

type Props = {
  chatInstanceId: number;
  queryIdentifier: string;
};

type Data = {
  feedback: Chat.QueryFeedback;
};
type Options = Omit<UseQueryOptions<Data, AxiosResponse, Data, QueryKey>, 'queryKey' | 'queryFn'>;
type QueryKey = readonly [string, Props];

function getQueryKey(props: Props): QueryKey {
  return [`query:get:feedback`, props] as const;
}

export const useQueryFeedbackQuery = (props: Props, options?: Options) => {
  const qk = getQueryKey(props);

  const apiClient = useChatApiClient();

  return useQuery({
    queryKey: qk,
    queryFn: ({ queryKey }) => {
      return apiClient.queries.getQueryFeedback({
        chatInstanceId: queryKey[1].chatInstanceId,
        queryIdentifier: queryKey[1].queryIdentifier,
      });
    },
    ...options,
  });
};